// removed by extract-text-webpack-plugin
module.exports = {"root":"_1hkfg6k"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/Search/components/RefineBar/components/DateListed/DateListed.less
 ** module id = 918
 ** module chunks = 0
 **/